import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import SBProMenuProduct from '@structural/menu-products-own.vue';
import SBProMenuTech from '@structural/menu-techs-own.vue';
import SBProMenuAbout from '@structural/menu-about.vue';
import SBProMenuPages from '@structural/menu-pages.vue';
import SBProMenuJoinus from '@structural/menu-joinus.vue';
let TopNav = class TopNav extends Vue {
    constructor() {
        super(...arguments);
        this.isTransparentFixed = false;
        this.scrolledClassAdded = false;
    }
    get topNavClassesComputed() {
        if (this.scrolledClassAdded) {
            return `${this.topNavClasses} navbar-scrolled`;
        }
        return this.topNavClasses;
    }
    mounted() {
        if (this.topNavClasses.match('bg-transparent') &&
            this.topNavClasses.match('fixed-top')) {
            this.isTransparentFixed = true;
        }
        window.document.body.onscroll = () => {
            if (!this.isTransparentFixed) {
                return;
            }
            if (window.scrollY > 0 && !this.scrolledClassAdded) {
                this.scrolledClassAdded = true;
                return;
            }
            if (window.scrollY === 0) {
                this.scrolledClassAdded = false;
            }
        };
    }
};
__decorate([
    Prop({ default: 'fixed-top' })
], TopNav.prototype, "topNavClasses", void 0);
__decorate([
    Prop({ default: 'text-primary' })
], TopNav.prototype, "brandClasses", void 0);
__decorate([
    Prop({ default: 'btn-primary' })
], TopNav.prototype, "buttonClasses", void 0);
TopNav = __decorate([
    Component({
        components: {
            'sbpro-menu-product': SBProMenuProduct,
            'sbpro-menu-tech': SBProMenuTech,
            'sbpro-menu-about': SBProMenuAbout,
            'sbpro-menu-pages': SBProMenuPages,
            'sbpro-menu-joinus': SBProMenuJoinus,
        },
    })
], TopNav);
export default TopNav;
